import React from 'react';
import { Route, Redirect } from "react-router-dom";
import { disAuthenticated } from "./driverIndex";

// Gate that wraps every authenticated driver route.
//   - Not signed in                       -> /driverSignin
//   - Signed in + mustChangePassword=true -> /driver/firstlogin
//   - Otherwise                           -> render the requested component
//
// Backend sets mustChangePassword=true when an admin issues a temp password
// via the invite flow. Clearing it requires a successful change-password.
const FIRSTLOGIN_PATH = '/driver/firstlogin';

const DriverRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        const session = disAuthenticated();
        if (!session) {
          return (
            <Redirect to={{ pathname: "/driverSignin", state: { from: props.location } }} />
          );
        }
        const mustChange = session?.driver?.mustChangePassword === true;
        if (mustChange && props.location.pathname !== FIRSTLOGIN_PATH) {
          return <Redirect to={{ pathname: FIRSTLOGIN_PATH }} />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default DriverRoute;
